<template>
  <div> 
    <b-container fluid>
      <nav-bar-component v-on:validated-user="companyId = $event; fetchRawEvents();"></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </b-container>
    
    <b-container fluid class="event-stream-container">
      <b-row >
        <b-col></b-col>
        <b-col cols="5">
          
            <b-card title="Event stream" sub-title="Latest events and live updates. Use the event stream to debug your latest notifications.">
              <b-table hover 
                      :items="rawEventList" 
                      :fields="tableFields" 
                      selectable 
                      :select-mode="selectMode" 
                      @row-selected="onRowSelected">
              </b-table>
            </b-card>
        </b-col>
        <b-col cols="5">
          <div class="sticky-top"> 
            <div>
          <b-card-group deck>
            <b-card title="Raw data">
       
              <b-card-text class="rawBody">{{selectedEventObj.body}}</b-card-text>

            </b-card>
          </b-card-group>
          </div>
          <div class="mt-3">
          <b-card-group deck>
            <b-card >
              <b-card-text class="mergedBody">{{selectedMergedMessage}}</b-card-text>

              <b-button :href="message.btn1Url" 
                      size="sm" 
                      :variant="message.btn1DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button1" 
                      v-show="message.showBtn1"
                      @click="registerButtonClick(message, 'btn1')">
              {{message.btn1Label}}
            </b-button>
            <b-button :href="message.btn2Url" 
                      size="sm" 
                      :variant="message.btn2DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button2" 
                      v-show="message.showBtn2"
                      @click="registerButtonClick(message, 'btn2')">
              {{message.btn2Label}}
            </b-button>
            <b-button :href="message.btn3Url" 
                      size="sm" 
                      :variant="message.btn3DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button3" 
                      v-show="message.showBtn3"
                      @click="registerButtonClick(message, 'btn3')">
              {{message.btn3Label}}
            </b-button>

              <template v-slot:footer >
                <small><timeago class="text-muted" id="timeago-component" :datetime="selectedEventObj.createdAt" :auto-update="60" v-b-tooltip.hover.right="selectedEventObj.createdAt"></timeago></small>
              </template>
            </b-card>
          </b-card-group>
          </div>
          </div>
        </b-col>
        <b-col></b-col>
      </b-row>
      
    </b-container>
  </div>
</template>

<script>
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'

const toEmoji = require("emoji-name-map")
// @ is an alias to /src
// Your corresponding keys
var moment = require('moment');
var Parse = require('parse');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'EventStream',
  components : {
    NavBarComponent,
    SetupMenuNavComponent,
  },
  data: function () {
    return {
      companyId: '',
      rawEventList : [],
      tableFields : [
          {
            key: 'createdAt',
            label: 'Timestamp',
            sortable: false
          },
          {
            key: 'subscriber_id',
            sortable: false
          },
          {
            key: 'event_id',
            sortable: false
          },
        ],
      selectedEvent : [],
      selectedEventObj : {createdAt : moment().format(), body : '{}'},
      selectedMessageObj : {},
      selectedMergedMessage : '👈 Select an event to show the message here',
      selectMode : 'single',
      message : {}
    }
  },

  mounted: function () {
    //this.fetchRawEvents();
  },
  
  created() {
    
  },
  
  methods: {
    fetchRawEvents() {
      
      console.log('fetch user - this.companyId = ', this.companyId);
      const RawEvent = Parse.Object.extend("RawEvent");
      const query = new Parse.Query(RawEvent);
      query.equalTo("app_id", this.companyId );
      query.descending("createdAt");
      query.limit(25);
      query.find().then((tempEventList) => {
        //this.wrapEventTypes(tempEventList);
        //console.log('temp event list = ' + JSON.stringify(tempEventList));          
        tempEventList.forEach(cur => {
          this.rawEventList.push(this.wrapEvent(cur));
        });

        //setup live query
        let LiveQueryClient = Parse.LiveQueryClient;
        console.log(process.env.VUE_APP_PARSE_LIVE_QUERY_SERVER_URL);
        let client = new LiveQueryClient({
          applicationId: process.env.VUE_APP_PARSE_APP_ID,
          serverURL: process.env.VUE_APP_PARSE_LIVE_QUERY_SERVER_URL,
          javascriptKey: process.env.VUE_APP_PARSE_JS_KEY
        });
        console.log(JSON.stringify(client));
        client.additionalProperties = false;
        console.log('one more time: ' + JSON.stringify(client));
        client.open();
        
        let subscription = client.subscribe(query);
        console.log('sub info: ' + JSON.stringify(subscription));
        subscription.on('create', (obj) =>
        {
          console.log('create', obj.attributes);          
          let curWrapper = this.wrapEvent(obj);
          curWrapper._rowVariant = 'info';
          this.rawEventList.unshift(curWrapper);
          
        });

      });
       
    },

    wrapEvent(rawEvent) {
      let createdTime = moment(rawEvent.createdAt).format();
      let eventWrapper = {
        createdAt : createdTime,
        subscriber_id : rawEvent.get('subscriber_id'),
        body : rawEvent.get('body'),
        event_id : rawEvent.get('event_id'),
        app_id : rawEvent.get('app_id'),
        id : rawEvent.id
      }
      return eventWrapper;
    },

    onRowSelected(item) {
      console.log('item = ' + item);
      this.selectedEvent = item;
      this.selectedEventObj = item[0];

      //const RawEvent = Parse.Object.extend("RawEvent");
      const AppMessage = Parse.Object.extend("AppMessage");
      const messageQuery = new Parse.Query(AppMessage);
      messageQuery.equalTo("RawEventId", { "__type": "Pointer", "className": "RawEvent", "objectId": this.selectedEventObj.id });
      messageQuery.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.selectedEventObj.app_id });
      
      messageQuery.first().then(messageResult => {
        this.selectedMessageObj = messageResult;
        let originalMessage = messageResult.get('Body');
        let mergedMessage = this.emojiMerge(originalMessage);
        this.selectedMergedMessage = mergedMessage;
        let jsonObj = messageResult.toJSON();
        this.wrapMessage(mergedMessage, jsonObj.createdAt, messageResult);
      })
    },

    wrapMessage(messageToWrap, timeval, messageObj) {
      console.log('*** message obj = ' + messageObj);
      console.log('*** message obj stringy = ' + JSON.stringify(messageObj));
      let curWrapper = {
        messageId : messageObj.id,
        messageText : messageToWrap,
        status : messageObj.get('Status'),
        rawtime : timeval,
        formattedTime : moment(timeval).format('MMM DD YYYY hh:mmA'),
        showBtn1 : false,
        showBtn2 : false,
        showBtn3 : false
      }
      if (messageObj.get('Button1Label')) {
        curWrapper['showBtn1'] = true;
        curWrapper['btn1Label'] = messageObj.get('Button1Label');
        curWrapper['btn1Url'] = messageObj.get('Button1Url');
        curWrapper['btn1DisplayAs'] = messageObj.get('Button1DisplayAs');
      }
      if (messageObj.get('Button2Label')) {
        curWrapper['showBtn2'] = true;
        curWrapper['btn2Label'] = messageObj.get('Button2Label');
        curWrapper['btn2Url'] = messageObj.get('Button2Url');
        curWrapper['btn2DisplayAs'] = messageObj.get('Button2DisplayAs');
      }
      if (messageObj.get('Button3Label')) {
        curWrapper['showBtn3'] = true;
        curWrapper['btn3Label'] = messageObj.get('Button3Label');
        curWrapper['btn3Url'] = messageObj.get('Button3Url');
        curWrapper['btn3DisplayAs'] = messageObj.get('Button3DisplayAs');
      }
      this.message = curWrapper;
    },
    
    emojiMerge(originalMessage) {
      let mergedMessage = originalMessage;
      console.log('orig message = ' + originalMessage);
      const re = /:[^:\s]*(?:::[^:\s]*)*:/gi;
      if (re.test(originalMessage)) {
        var emojiAlphas = [...originalMessage.match(re)];
        //var emojiAlphas = originalMessage.matchAll(re);
        console.log('emojiAlphas = ' + emojiAlphas);
        if (emojiAlphas) {
          for (const cur of emojiAlphas) {
            console.log('cur = ' + cur);
            console.log('emoji! : ' + toEmoji.get(cur));
            if (toEmoji.get(cur)) {
              mergedMessage = originalMessage.replace(new RegExp(cur, 'g'), toEmoji.get(cur));
            }
          }
        }
      }
      return mergedMessage;
    },
  }
}
</script>

<style >
.rawBody {
  white-space: pre-wrap;
}
.mergedBody {
  white-space: pre-wrap;
}
.event-stream-container {
  margin-top:20px;
}
</style>
